// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3780 ? "a7f1ff53" : chunkId) + "." + {"294":"b2d121590d71b8cc","436":"d69a771fbfbdf607","851":"ba3aa28eacbaebff","1260":"c22df305e67f0f63","3780":"0c0aaa463a8564e5"}[chunkId] + ".js";
};